import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import AGB from './views/AGB.vue'
import Datenschutz from './views/Datenschutz.vue'
import Impressum from './views/Impressum.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/ref/:ref_id?',
      alias: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Startseite'
      }
    },
    {
      path: '/details',
      name: 'details',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "details" */ './views/Details.vue'),
      meta: {
        title: 'Details'
      }
    },
    {
      path: '/signup-success',
      name: 'signup-success',
      component: () => import(/* webpackChunkName: "signup-success" */ './views/SignupSuccess.vue'),
      props: true,
      meta: {
        title: 'Registrierung erfolgreich'
      }
    },
    {
      path: '/agb',
      name: 'agb',
      component: AGB,
      meta: {
        title: 'Allgemeine Geschäftsbedingungen (AGB)'
      }
    },
    {
      path: '/datenschutz',
      name: 'datenschutz',
      component: Datenschutz,
      meta: {
        title: 'Datenschutz'
      }
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: Impressum,
      meta: {
        title: 'Impressum'
      }
    },
    {
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: "error" */ './views/Error.vue'),
      props: true,
      meta: {
        title: 'Fehler (Registrierung)'
      }
    }
  ],
  // eslint-disable-next-line
  scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
  }
})
